import { Designation } from "../types"
import { DonationSummary } from "./DonationSummary"
import { PaymentMethodSelector } from "./PaymentMethodSelector"

type RightPaneProps = {
  designations: Designation[]
  desktop: boolean
  totalCents: number
}
export function RightPane({
  designations = [],
  desktop,
  totalCents,
}: RightPaneProps) {
  return (
    <div className="f-1 d-f fd-c g-2">
      {!desktop && <DonationSummary {...{ designations, totalCents }} />}
      <PaymentMethodSelector />
    </div>
  )
}
